/**
 * Converts raw millisecond scores to formatted time string with milliseconds and no rounding.
 *
 * @param durationInMs - Time in milliseconds
 * @returns Formatted time string in "H:MM:SS.ms" format
 *
 * @example
 * hiFidelityTime(3661234) // "1:01:01.234"
 * hiFidelityTime(125000)  // "0:02:05"
 * hiFidelityTime(61500)   // "0:01:01.5"
 *
 * Note: Leading zeros are removed from hours, trailing zeros are removed from milliseconds
 */
export function hiFidelityTime(durationInMs: number) {
  const milliseconds = durationInMs % 1000
  const totalSeconds = Math.floor(durationInMs / 1000)
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60

  const hoursStr = hours.toString().replace(/^0+/, '') || '0'
  const mm = minutes.toString().padStart(2, '0')
  const ss = seconds.toString().padStart(2, '0')
  const ms = milliseconds.toString().padStart(3, '0').replace(/0+$/, '')

  return `${hoursStr}:${mm}:${ss}.${ms}`
}
